var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6673 1.66663H5.00065C4.07565 1.66663 3.33398 2.40829 3.33398 3.33329V16.6666C3.33398 17.1087 3.50958 17.5326 3.82214 17.8451C4.1347 18.1577 4.55862 18.3333 5.00065 18.3333H15.0007C15.4427 18.3333 15.8666 18.1577 16.1792 17.8451C16.4917 17.5326 16.6673 17.1087 16.6673 16.6666V6.66663L11.6673 1.66663ZM10.4507 16.1416V14.475H7.11732V12.8166H10.4507V11.15L12.9507 13.65L10.4507 16.1416ZM10.834 7.49996V2.91663L15.4173 7.49996H10.834Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSend);
export default __webpack_public_path__ + "static/media/file-send.716d717ba5cd59d08e68745d4e3285f0.svg";
export { ForwardRef as ReactComponent };